export const CHANGE_TOPBAR_HEADING = 'CHANGE_TOPBAR_HEADING';
export const SET_ALL_CONFIGS = 'SET_ALL_CONFIGS';
export const GET_CLIENT_INFO = 'GET_CLIENT_INFO';
export const SET_CLIENT_ID = 'SET_CLIENT_ID';
export const SET_STATS_VIEW = 'SET_STATS_VIEW';

const initialState = {
  tobarheading: '',
  clientID: '',
  statusView: false,
  allConfigs: {
    'UI Config': {
      lead_card_info: ''
    }
  },
  clientInfo: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_ID:
      return {
        ...state,
        clientID: action.payload
      };

    case SET_STATS_VIEW:
      return {
        ...state,
        statusView: action.payload
      };

    case CHANGE_TOPBAR_HEADING:
      return {
        ...state,
        tobarheading: action.payload
      };

    case SET_ALL_CONFIGS:
      return {
        ...state,
        allConfigs: action.payload
      };

    case GET_CLIENT_INFO:
      return {
        ...state,
        clientInfo: action.payload
      };

    default:
      return state;
  }
};
